<template>
  <v-container>
    <v-row dense>
      <v-col
        v-for="(link, i) in _links"
        :key="i"
        cols="12"
      >
        <v-card
          color="accent"
          dark
          :to="link.to"
        >
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title
                class="headline"
                v-text="link.title"
              ></v-card-title>
            </div>

            <v-icon size="64" class="ma-3">{{link.icon}}</v-icon>

          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'dashboard',
  data () {
    return {}
  },
  computed: {
    ...mapGetters('tradle', {
      _links: 'links'
    })
  },
  mounted () {
  }
}
</script>

<style>
</style>
